import $ from 'jquery';

export const sendReminderEmail = (html, email, subject, _id) => {
  return function (dispatch, getState) {
    return new Promise((resolve, reject) => {
      let url = 'email/sendReminderEmail';
      //let url = '/testerror';
      $.ajax({
        url,
        type: "POST",
        data: {
          email,
          html,
          subject,
          _id
        },
        success: (result) => {
          if (result.authError) {
            alert('user is not authorized.')
          }
          resolve(result);
        },
        error: (err) => {
          console.log(err);
          reject(err);
        }
      })

    })
  }
}

